import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  templateUrl: './park-filter-item.html',
  selector: 'park-filter-item'
})
export class ParkFilterItemComponent {
  @Input() public label: string;
  @Input() public value: any;
  @Input() public checked: boolean;
  @Output() public change: EventEmitter<{ checked: boolean, value: any }> = new EventEmitter();

  public onChange($event) {
    this.change.emit($event);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/filter/filter-item/park-filter-item.component.ts